export default {
    favorites: 'Favoritos',
    relationship: 'Buscando Relacionamento',
    message: 'Visando a otimização da performance de nossos recursos, a partir do dia {date}, o recurso "{feature}" será desativado. Sentimos muito pelo transtorno, estamos melhorando nossos processos para que você tenha uma melhor experiência.'
};